import { Component, OnInit, Input } from '@angular/core';
import { SaveSearchService } from 'projects/shared/core/services/save-search.service';

@Component({
  selector: 'ndms-program-card',
  templateUrl: './program-card.component.html',
  styleUrls: ['./program-card.component.scss']
})

export class ProgramCardComponent implements OnInit {
  @Input ('url') programUrl: string;
  @Input('title') programName: string;
  @Input('description') programIconClass: string;
  @Input('visible') programAccessible: boolean;
  
  constructor(private _saveSearchService: SaveSearchService) { }

  private pagesToClear = [
    { route: "/rms/events/event-search", key: "eventSearch" },
    { route: "/rms/deployment/roster-search", key: "rosterSearch" },
    { route: "/rms/responders/responder-search", key: "responderSearch" },
    { route: "/rms/travel/travel-roster-search", key: "travelRosterSearch" }
  ];

  ngOnInit() { }

  isProgramAccessible(): boolean {
    return this.programAccessible;
  }

  isLegacyUrl(url) {
    return url.includes('.jsp');
  }

  shouldProgramClear(): boolean {
    return !!this.pagesToClear.find(p => p.route == this.programUrl);
  }

  freshNav(event?) {
    //Instruct savesearchservice to clear the form, except on right click
    if (event.button != 2) this._saveSearchService.clearSavedForm(this.pagesToClear.find(p => p.route == this.programUrl).key);
  }
}
